import { useAppSelector } from 'app/hooks';
import { Menu } from 'features/MenuBook/models';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { getListStyle } from '../MenuBookEditorModal';
import SubMenuGroupRow from '../SubMenuGroupRow';
import SubMenuRowList from '../SubMenuRowList';

export interface SubMenuGroupRowListProps {
  genreId: number;
  subgenreId: number;
  menuId: number;
}

function SubMenuGroupRowList({ genreId, subgenreId, menuId }: SubMenuGroupRowListProps) {
  const menu = useAppSelector((state) => {
    return state.menuBookEditor.data
      .flatMap((genre) => (genre.id === genreId ? genre.subgenres : []))
      .flatMap((subgenre) => (subgenre.id === subgenreId ? subgenre.menus : []))
      .find((menu) => menu.id === menuId);
  }) as Menu;

  const pathId = `${genreId}-${subgenreId}-${menu.id}`;

  return (
    <Droppable droppableId={`menu-${pathId}`} type={`sub_menu_group-${pathId}`}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {menu.sub_menu_groups.map((subMenuGroup, index) => (
            <SubMenuGroupRow
              key={`sub_menu_group-${pathId}-${subMenuGroup.id}`}
              genreId={genreId}
              subgenreId={subgenreId}
              menuId={menuId}
              subMenuGroupId={subMenuGroup.id}
              index={index}
            >
              <SubMenuRowList
                genreId={genreId}
                subgenreId={subgenreId}
                menuId={menu.id}
                subMenuGroupId={subMenuGroup.id}
              />
            </SubMenuGroupRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(SubMenuGroupRowList);
